import React from "react";
import HubspotForm from "./HubspotForm";

export default function MisimDemoForm() {
  const urlApi = process.env.REACT_APP_STRAPI_URL;
  return (
    <div className="bg-sidom-light dark:bg-sidom-blue flex flex-col relative overflow-hidden">
      <video
        autoPlay
        loop
        muted
        playsInline
        className="absolute inset-0 w-full h-full object-cover z-0"
      >
        <source
          src={`${urlApi}/uploads/Dots_Background_15_1_0a34ee2d0d.mp4`}
          type="video/mp4"
        />
      </video>
      <div className="relative  flex flex-col mb-[70px] md:mb-[100px] lg:mb-[90px] ">
        <main className="flex-1 flex flex-col items-center justify-center px-2 md:px-0 lg:px-0">
          <h1 className="text-3xl md:text-[40px] lg:text-[45px] leading-tight mt-[70px] md:mt-[100px] lg:mt-[90px] md:text-5xl font-extrabold text-sidom-orange mb-8 text-center">
            ¡Solicitá tu demo de MiSIM!
          </h1>
          <div className="w-full md:w-[600px] lg:w-[800px] xl:w-[1000px] 2xl:w-[1200px]">
            <HubspotForm />
          </div>
        </main>
      </div>
    </div>
  );
}
